export const MARGIN_BIG = "20px";
export const MARGIN = "10px";
export const CHAMFER = "20px";
export const CHAMFER_BIG = "50px";
